import Link from "next/link"
import type { ReactNode } from "react"

import { Button } from "@/components/ui/button"
import {
  storyHrefFromScopeSource,
  storyHrefToEventChapter,
  type StoryScopeSource,
} from "@/lib/story/story-routes"
import { cn } from "@/lib/utils"

export type StoryScopeOutlineLinkProps = {
  source: StoryScopeSource
  /** When set, opens Story scrolled to this event’s chapter. */
  focusEventId?: string
  label: ReactNode
  className?: string
}

/**
 * Matches event page secondary actions: outline pill + optional deep link to a chapter.
 */
export function StoryScopeOutlineLink({
  source,
  focusEventId,
  label,
  className,
}: StoryScopeOutlineLinkProps) {
  const href = focusEventId?.trim()
    ? storyHrefToEventChapter(source, focusEventId)
    : storyHrefFromScopeSource(source)
  if (!href) return null

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn(
        "rounded-full border-border/50 bg-card/40 backdrop-blur-sm",
        className,
      )}
      asChild
    >
      <Link
        href={href}
        className="inline-flex min-w-0 items-center justify-center gap-1"
      >
        {label}
      </Link>
    </Button>
  )
}
